// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBar_search__3BO5S","screenReaderText":"SearchBar_screenReaderText__2UdGC"};